/**
 * Notice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The Family model module.
 * @module model/Family
 * @version 1.0
 */
class Family {
    /**
     * Constructs a new <code>Family</code>.
     * @alias module:model/Family
     */
    constructor() { 
        
        Family.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>Family</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Family} obj Optional instance to populate.
     * @return {module:model/Family} The populated <code>Family</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Family();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
        }
        return obj;
    }


}

/**
 * Class Family
 * @member {Number} id
 */
Family.prototype['id'] = undefined;

/**
 * Class Family
 * @member {String} name
 */
Family.prototype['name'] = undefined;






export default Family;

